import { Fragment, useState, useRef, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Select from 'react-select'
import { API_URL } from '../../utils/Constants/URLS'
import 'primereact/resources/themes/lara-light-cyan/theme.css'
import Modal from 'react-bootstrap/Modal'
import { Toast } from 'primereact/toast'
import { useSelector } from 'react-redux'
import PageLoader from '../../utils/PageLoader'
import TerminateConfirmationModal from '../../Modals/TerminateConfirmationModal'

const ReachedAgreement = () => {
  const token = localStorage.getItem('token')
  const { id } = useParams()
  const toast = useRef(null)
  const [modalMessage, setModalMessage] = useState('')
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showDeclineModal, setShowDeclineModal] = useState(false)
  const [zeroDateOfDelivery, setZeroOfDateDelivery] = useState('')
  const [customerPONumber, setCustomerPONumber] = useState('')
  const [isPOAvailable, setIsPoAvailable] = useState('true')
  const [PODetails, setPoDetails] = useState('')
  const [POFilePath, setPoFilePath] = useState('')
  const [customerPODate, setCustomerPODate] = useState('')
  const [gsplGSTNumber, setGsplGSTNumber] = useState('')
  const [consultant, setConsultant] = useState('')
  const [currencyOfTransaction, setCurrencyOfTransaction] = useState('')
  const [checkShipping, setCheckShipping] = useState(false)
  const [billingAddress, setBillingAddress] = useState('')
  const [shippingAddress, setShippingAddress] = useState('')
  const [selectedBillingNick, setSelectedBillingNick] = useState('')
  const [selectedShippingNick, setSelectedShippingNick] = useState('')
  const [warrantyPeriod, setWarrantyPeriod] = useState('')
  const [remarks, setRemarks] = useState('')
  const [warrantyTerms, setWarrantyTerms] = useState('')
  const [bankGuaranteeDetails, setbankGuaranteeDetails] = useState([])
  const [bankGuaranteeDetailsPercent, setBankGuaranteeDetailsPercent] = useState('')
  const [managerDetails, setManagerDetails] = useState([])
  const [manager, setManager] = useState('')
  const [typeOfTransaction, setTypeOfTransaction] = useState('')
  const [BOMFilePath, setBOMFilePath] = useState('')
  const [finalOrderDocPath, setFinalOrderDocPath] = useState('')
  const [responsibilityOfTransportation, setResponsibilityOfTransportation] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const poFileInputRef = useRef(null)
  const bomFileInputRef = useRef(null)
  const finalOrderDocInputRef = useRef(null)
  const csvFileInputRef = useRef(null) // NEW: CSV file ref

  const [paymentTerms, setPaymentTerms] = useState([
    { type: '', percentage: '', amount: '', otherDetails: '' }
  ])
  const [priceBasis, setPriceBasis] = useState('')
  const [salesOrder, setSalesOrder] = useState([])
  const navigate = useNavigate()
  const leadDetails = useSelector(store => store.deal)
  const userDetails = useSelector(store => store.user)
  let totalDealValue = 0

  if (leadDetails?.leadType === 'Direct') {
    const salesCommissionItem = leadDetails?.productRequirements?.crossSells?.find(item =>
      item?.model?.modelName?.toLowerCase().startsWith('sales commission')
    )
    if (salesCommissionItem) {
      totalDealValue = Number(salesCommissionItem?.value || 0)
    }
  } else {
    totalDealValue = Number(leadDetails?.productRequirements?.proposedDealAmount || 0)
  }

  const bankGuaranteeDetailsData = [
    { value: 'NA', label: 'NA' },
    { value: 'ABG', label: 'ABG' },
    { value: 'CPBG', label: 'CPBG' },
    { value: 'PBG', label: 'PBG' }
  ]

  const handleCloseModal = () => {
    setShowSuccessModal(false)
    setShowDeclineModal(false)
    navigate('/view_leads')
  }

  useEffect(() => {
    const fetchSalesOrder = async () => {
      try {
        const url = `${API_URL}leads/sales-orders/6805ef9d73d8679cbc61a5ee`
        const res = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })
        const result = await res.json()
        setSalesOrder(result?.data)
      } catch (error) {
        console.error(error)
      }
    }
    fetchSalesOrder()
  }, [token])

  useEffect(() => {
    const fetchManagers = async () => {
      const searchParam = userDetails?.role === 'executive' ? 'manager' : 'commercial_manager'
      const url = `${API_URL}users/org-contacts?pagination=false&search=${searchParam}`
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })
        const result = await response.json()
        setManagerDetails(
          result.data.docs.map(data => ({
            value: data._id,
            label: data.name
          }))
        )
      } catch (error) {
        console.error('Error fetching org contacts:', error)
      }
    }
    fetchManagers()
  }, [token])

  const updateLead = async () => {
    try {
      const res = await fetch(`${API_URL}leads/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          agreement: {
            stage: 'won'
          }
        })
      })
      const response = await res.json()
    } catch (e) {
      setModalMessage('Oops! Error while adding data')
      setShowDeclineModal(true)
    }
  }

  const uploadFiles = async () => {
    const poFileInput = poFileInputRef.current
    const finalOrderDocInput = finalOrderDocInputRef.current

    let uploadedPOPath = null
    let uploadedFinalOrderDocPath = null

    // Upload PO file if PO is available
    if (isPOAvailable === 'true') {
      if (!poFileInput || !poFileInput.files || poFileInput.files.length === 0) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Please upload PO file',
          life: 3000
        })
        return null
      }

      try {
        const myHeaders = new Headers()
        myHeaders.append('Authorization', `Bearer ${token}`)
        const formdata = new FormData()
        formdata.append('pdf', poFileInput.files[0])
        formdata.append('category', 'purchase-orders')

        const uploadRes = await fetch(`${API_URL}file/upload`, {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        })
        const uploadResult = await uploadRes.json()

        if (uploadResult && uploadResult.data) {
          uploadedPOPath = typeof uploadResult.data === 'string'
            ? uploadResult.data
            : uploadResult.data.filePath
        }

        if (!uploadedPOPath) {
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'PO file upload failed',
            life: 3000
          })
          return null
        }

        setPoFilePath(uploadedPOPath)
      } catch (err) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'PO file upload failed',
          life: 3000
        })
        return null
      }
    }

    // Upload Final Order Doc (optional)
    if (finalOrderDocInput && finalOrderDocInput.files && finalOrderDocInput.files.length > 0) {
      try {
        const myHeaders = new Headers()
        myHeaders.append('Authorization', `Bearer ${token}`)
        const formdata = new FormData()
        formdata.append('pdf', finalOrderDocInput.files[0])
        formdata.append('category', 'final-order-docs')

        const uploadRes = await fetch(`${API_URL}file/upload`, {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        })
        const uploadResult = await uploadRes.json()

        if (uploadResult && uploadResult.data) {
          uploadedFinalOrderDocPath = typeof uploadResult.data === 'string'
            ? uploadResult.data
            : uploadResult.data.filePath
        }

        if (!uploadedFinalOrderDocPath) {
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'Final Order Doc upload failed',
            life: 3000
          })
          return null
        }

        setFinalOrderDocPath(uploadedFinalOrderDocPath)
      } catch (err) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Final Order Doc upload failed',
          life: 3000
        })
        return null
      }
    }

    // BOM CSV is no longer uploaded here — it is sent directly
    // as 'bomFile' in the sales order creation request and handled by the backend
    return {
      poPath: uploadedPOPath,
      finalOrderDocPath: uploadedFinalOrderDocPath
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (zeroDateOfDelivery === '') {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please Select Zero Date Delivery', life: 3000 })
      return
    }
    if (gsplGSTNumber === '') {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please Select GSPL GST Number', life: 3000 })
      return
    }
    if (currencyOfTransaction === '') {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please Select Currency of Transaction', life: 3000 })
      return
    }
    if (warrantyPeriod === '') {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please Enter Warranty Period from Date of commissioning', life: 3000 })
      return
    }
    if (warrantyTerms === '') {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please Enter Warranty Period from last date of supply', life: 3000 })
      return
    }
    if (responsibilityOfTransportation === '') {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please Select Responsibility of Transportation', life: 3000 })
      return
    }
    if (typeOfTransaction === '') {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please Select Type of Transaction', life: 3000 })
      return
    }
    if (!bankGuaranteeDetails || bankGuaranteeDetails.length === 0) {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please Select Bank Guarantee Details', life: 3000 })
      return
    }
    if (billingAddress === '') {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please Enter Billing Address', life: 3000 })
      return
    }
    if (!checkShipping && shippingAddress === '') {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please Enter Shipping Address', life: 3000 })
      return
    }
    if (!manager || manager === '') {
      toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please Select a Manager', life: 3000 })
      return
    }

    for (let i = 0; i < paymentTerms.length; i++) {
      const term = paymentTerms[i]
      if (!term.type || term.percentage === '' || term.amount === '') {
        toast.current?.show({ severity: 'error', summary: 'Error', detail: `Please complete all fields in Payment Term ${i + 1}`, life: 3000 })
        return
      }
    }

    const totalPercentageRaw = paymentTerms.reduce((acc, term) => acc + (parseFloat(term.percentage) || 0), 0)
    const totalPercentage = Math.round(totalPercentageRaw * 100) / 100
    if (totalPercentage !== 100) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: `Total Payment Terms percentage must be exactly 100%. Currently it is ${totalPercentage.toFixed(2)}%.`,
        life: 4000
      })
      return
    }

    let poDetailsToSend = undefined
    if (isPOAvailable === 'true') {
      if (customerPONumber === '') {
        toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please Enter Customer PO Number', life: 3000 })
        return
      }
      if (customerPODate === '') {
        toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Please Select Customer PO Date', life: 3000 })
        return
      }
      poDetailsToSend = undefined
    } else {
      if (
        customerPONumber !== '' ||
        customerPODate !== '' ||
        (poFileInputRef.current && poFileInputRef.current.files && poFileInputRef.current.files.length > 0)
      ) {
        toast.current?.show({
          severity: 'warn',
          summary: 'Warning',
          detail: 'PO Number, PO Date, and PO File should not be entered when PO is not available.',
          life: 4000
        })
        return
      }
      poDetailsToSend = PODetails
    }

    setSubmitting(true)

    try {
      // Only upload PO and finalOrderDoc — BOM CSV is sent directly with the SO request
      const uploadResults = await uploadFiles()
      if (!uploadResults) {
        setSubmitting(false)
        return
      }

      const { poPath, finalOrderDocPath: uploadedFinalDocPath } = uploadResults

      if (isPOAvailable === 'true' && !poPath) {
        toast.current?.show({ severity: 'error', summary: 'Error', detail: 'PO file upload failed', life: 3000 })
        setSubmitting(false)
        return
      }

      const formdata = new FormData()

      // Scalar fields
      formdata.append('lead', leadDetails.id || leadDetails._id)
      formdata.append('zeroDateOfDelivery', zeroDateOfDelivery)
      formdata.append('customerPONumber', customerPONumber)
      formdata.append('customerPODate', customerPODate)
      formdata.append('gsplGSTNumber', gsplGSTNumber)
      formdata.append('consultant', consultant)
      formdata.append('currencyOfTransaction', currencyOfTransaction)
      formdata.append('billingAddress', billingAddress)
      formdata.append('shippingAddress', checkShipping ? billingAddress : shippingAddress)
      formdata.append('warrantyPeriod', warrantyPeriod)
      formdata.append('warrantyTerms', warrantyTerms)
      formdata.append('remarks', remarks)
      formdata.append('bankGuaranteeDetailsPercent', bankGuaranteeDetailsPercent)
      formdata.append('typeOfTransaction', typeOfTransaction)
      formdata.append('responsibilityOfTransportation', responsibilityOfTransportation)
      formdata.append('priceBasis', priceBasis)
      formdata.append('isPOAvailable', isPOAvailable)
      formdata.append('POFilePath', poPath || '')
      formdata.append('PODetails', poDetailsToSend || '')

      if (uploadedFinalDocPath) formdata.append('finalOrderDoc', uploadedFinalDocPath)

      // Arrays sent as JSON strings
      formdata.append('bankGuaranteeDetails', JSON.stringify(bankGuaranteeDetails))
      formdata.append(
        'paymentTerms',
        JSON.stringify(
          paymentTerms.map(term => ({
            type: term.type,
            percentage: Number(term.percentage),
            amount: Number(term.amount),
            otherDetails: term.otherDetails || ''
          }))
        )
      )

      // BOM CSV — single append using bomFile field name, sent directly to SO creation endpoint
      // Backend multer expects upload.single('bomFile')
      // Backend will: parse line items from CSV + store file path as BOMFilePath
      if (bomFileInputRef.current?.files?.length > 0) {
        formdata.append('bomFile', bomFileInputRef.current.files[0])
      }

      const res = await fetch(`${API_URL}leads/sales-orders`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`
        },
        body: formdata
      })

      const response = await res.json()

      if (response.error === false) {
        const salesOrderId = response.data._id || response.data.id
        if (salesOrderId) {
          try {
            await assignManager(salesOrderId)
            setModalMessage('Sales Order Created and Manager Assigned Successfully Please Wait for Approval')
            setShowSuccessModal(true)
            await updateLead()
          } catch (managerError) {
            console.error('Manager assignment/update error:', managerError)
            setModalMessage('Sales Order Created but Manager Assignment Failed')
            setShowDeclineModal(true)
          }
        } else {
          setModalMessage('Sales Order Created but Missing ID for Manager Assignment')
          setShowDeclineModal(true)
        }
      } else {
        setModalMessage('Failed to Create Sales Order')
        setShowDeclineModal(true)
      }
    } catch (e) {
      console.error('handleSubmit error:', e)
      setModalMessage('Oops! Error while adding data')
      setShowDeclineModal(true)
    } finally {
      setSubmitting(false)
    }
  }
  const assignManager = async salesOrderId => {
    try {
      const managerKey = userDetails?.role === 'executive' ? 'manager' : 'commercialManager'
      const res = await fetch(`${API_URL}leads/sales-orders/${salesOrderId}/approval/request`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          [managerKey]: manager
        })
      })
      const response = await res.json()
      console.log('Manager assignment response:', response)
      return response
    } catch (error) {
      console.error('Error assigning manager:', error)
      throw error
    }
  }

  const handlePaymentTermChange = (index, field, value) => {
    const updatedTerms = [...paymentTerms]
    if (field === 'amount') {
      updatedTerms[index].amount = value
      const numericAmount = parseFloat(value)
      if (!isNaN(numericAmount) && totalDealValue > 0) {
        updatedTerms[index].percentage = ((numericAmount / totalDealValue) * 100).toFixed(2)
      } else {
        updatedTerms[index].percentage = ''
      }
    } else if (field === 'percentage') {
      updatedTerms[index].percentage = value
      const numericPercent = parseFloat(value)
      if (!isNaN(numericPercent) && totalDealValue > 0) {
        updatedTerms[index].amount = ((numericPercent / 100) * totalDealValue).toFixed(2)
      } else {
        updatedTerms[index].amount = ''
      }
    } else {
      updatedTerms[index][field] = value
    }
    setPaymentTerms(updatedTerms)
  }

  const addPaymentTerm = () => {
    setPaymentTerms([...paymentTerms, { type: '', percentage: '', amount: '', otherDetails: '' }])
  }

  const removePaymentTerm = index => {
    setPaymentTerms(paymentTerms.filter((_, i) => i !== index))
  }

  useEffect(() => {
    if (checkShipping) {
      setShippingAddress(billingAddress)
    }
  }, [checkShipping, billingAddress])

  return (
    <Fragment>
      <div className='relative'>
        {submitting && (
          <div className='absolute inset-0 z-50 flex items-center justify-center'>
            <PageLoader />
          </div>
        )}
        <form className='row g-3 needs-validation' noValidate>
          {/* Zero Date Delivery */}
          <div className={isPOAvailable === 'true' ? 'col-md-4' : 'col-md-6'}>
            <label htmlFor='meetingDate' className='form-label'>
              Zero Date Delivery <span className='text-danger'>*</span>
            </label>
            <input
              value={zeroDateOfDelivery}
              onChange={e => setZeroOfDateDelivery(e.target.value)}
              name='meetingDate'
              min='2022-01-01'
              max='2099-12-31'
              className='form-control'
              type='date'
              id='meetingDate'
              onClick={e => e.target.showPicker && e.target.showPicker()}
            />
          </div>

          {/* Is PO Available */}
          <div className={isPOAvailable === 'true' ? 'col-md-4' : 'col-md-6'}>
            <label htmlFor='isPOAvailable' className='form-label'>
              Is PO Available? <span className='text-danger'>*</span>
            </label>
            <select
              id='isPOAvailable'
              value={isPOAvailable}
              onChange={e => setIsPoAvailable(e.target.value)}
              className='form-select'
              required
            >
              <option value='true'>Yes</option>
              <option value='false'>No</option>
            </select>
          </div>

          {/* PO Fields */}
          {isPOAvailable === 'true' ? (
            <>
              <div className='col-md-4'>
                <label htmlFor='customerPONumber' className='form-label'>
                  Customer PO Number <span className='text-danger'>*</span>
                </label>
                <input
                  value={customerPONumber}
                  onChange={e => setCustomerPONumber(e.target.value)}
                  type='text'
                  className='form-control'
                  required
                />
              </div>
              <div className='col-md-12'>
                <label htmlFor='uploadPO' className='form-label'>
                  Upload PO <span className='text-danger'>*</span>
                </label>
                <input ref={poFileInputRef} type='file' className='form-control' required />
              </div>
              <div className='col-md-4'>
                <label htmlFor='customerPODate' className='form-label'>
                  Customer PO Date <span className='text-danger'>*</span>
                </label>
                <input
                  value={customerPODate}
                  onChange={e => setCustomerPODate(e.target.value)}
                  name='meetingDate'
                  min='2022-01-01'
                  max='2099-12-31'
                  className='form-control'
                  type='date'
                  id='customerPODate'
                  onClick={e => e.target.showPicker && e.target.showPicker()}
                />
              </div>
            </>
          ) : (
            <div className='col-md-12'>
              <label htmlFor='poDetails' className='form-label'>
                PO Details <span className='text-danger'>*</span>
              </label>
              <textarea
                id='poDetails'
                value={PODetails}
                onChange={e => setPoDetails(e.target.value)}
                className='form-control'
                required
              />
            </div>
          )}

          {/* GSPL GSTIN */}
          <div className={isPOAvailable === 'true' ? 'col-md-4' : 'col-md-6'}>
            <label htmlFor='gsplGSTNumber' className='form-label'>
              GSPL GSTIN <span className='text-danger'>*</span>
            </label>
            <select
              className='form-select'
              value={gsplGSTNumber}
              onChange={e => setGsplGSTNumber(e.target.value)}
            >
              <option value=''>Select</option>
              <option value='19AAECG1743K1ZG'>19AAECG1743K1ZG</option>
              <option value='18AAECG1743K1ZI'>18AAECG1743K1ZI</option>
            </select>
          </div>

          {/* Consultant */}
          <div className={isPOAvailable === 'true' ? 'col-md-4' : 'col-md-6'}>
            <label htmlFor='consultant' className='form-label'>
              Consultant (If Any)
            </label>
            <input
              value={consultant}
              onChange={e => setConsultant(e.target.value)}
              type='text'
              className='form-control'
            />
          </div>

          {/* Currency of Transaction */}
          <div className='col-md-4'>
            <label htmlFor='currencyOfTransaction' className='form-label'>
              Currency Of Transaction <span className='text-danger'>*</span>
            </label>
            <select
              className='form-select'
              value={currencyOfTransaction}
              onChange={e => setCurrencyOfTransaction(e.target.value)}
            >
              <option value=''>Select</option>
              <option value='INR'>INR</option>
              <option value='USD'>USD</option>
            </select>
          </div>

          {/* Warranty Period from commissioning */}
          <div className='col-md-8'>
            <label htmlFor='warrantyPeriod' className='form-label'>
              Warranty Period from date of commissioning (in months)
              <span className='text-danger'>*</span>
            </label>
            <input
              value={warrantyPeriod}
              onChange={e => setWarrantyPeriod(e.target.value)}
              type='number'
              onWheel={e => e.target.blur()}
              className='form-control'
              required
            />
          </div>

          {/* Warranty Period from last supply */}
          <div className='col-md-8'>
            <label htmlFor='warrantyTerms' className='form-label'>
              Warranty Period from date of last supply (in months)
              <span className='text-danger'>*</span>
            </label>
            <input
              type='number'
              onWheel={e => e.target.blur()}
              value={warrantyTerms}
              onChange={e => setWarrantyTerms(e.target.value)}
              className='form-control'
              required
            />
          </div>

          {/* Price Basis */}
          <div className='col-md-4'>
            <label htmlFor='priceBasis' className='form-label'>
              Price Basis <span className='text-danger'>*</span>
            </label>
            <select
              className='form-select'
              value={priceBasis}
              onChange={e => setPriceBasis(e.target.value)}
            >
              <option value=''>Select</option>
              <option value='Ex- Works Factory'>Ex- Works Factory</option>
              <option value='Ex- Vendor Works'>Ex- Vendor Works</option>
              <option value='FOR Site'>FOR Site</option>
              <option value='Ex- Godown Bardhaman'>Ex- Godown Bardhaman</option>
              <option value='Ex- Godown Kolkata'>Ex- Godown Kolkata</option>
              <option value='Ex- Godown Siliguri'>Ex- Godown Siliguri</option>
              <option value='Ex- Godown Guwahati'>Ex- Godown Guwahati</option>
            </select>
          </div>

          {/* Responsibility of Transportation */}
          <div className='col-md-4'>
            <label htmlFor='responsibilityOfTransportation' className='form-label'>
              Responsibility of transportation <span className='text-danger'>*</span>
            </label>
            <select
              className='form-select'
              value={responsibilityOfTransportation}
              onChange={e => setResponsibilityOfTransportation(e.target.value)}
            >
              <option value=''>Select</option>
              <option value='GSPL'>GSPL</option>
              <option value='Customer'>Customer</option>
            </select>
          </div>

          {/* Type of Transaction */}
          <div className='col-md-4'>
            <label htmlFor='typeOfTransaction' className='form-label'>
              Type of Transaction <span className='text-danger'>*</span>
            </label>
            <select
              className='form-select'
              value={typeOfTransaction}
              onChange={e => setTypeOfTransaction(e.target.value)}
            >
              <option value=''>Select</option>
              <option value='Domestic'>Domestic</option>
              <option value='Export'>Export</option>
              <option value='Indirect Export'>Indirect Export</option>
              <option value='EPCG'>EPCG</option>
              <option value='Tax exempted'>Tax exempted</option>
            </select>
          </div>

          {/* Bank Guarantee Details */}
          <div className='col-md-8'>
            <label htmlFor='bankGuaranteeDetails' className='form-label'>
              Bank Guarantee Details <span className='text-danger'>*</span>
            </label>
            <Select
              options={bankGuaranteeDetailsData}
              onChange={selectedOptions =>
                setbankGuaranteeDetails(selectedOptions ? selectedOptions.map(option => option.label) : [])
              }
              isMulti={true}
            />
          </div>

          {/* Bank Guarantee Percent */}
          <div className='col-md-4'>
            <label htmlFor='bankGuaranteeDetailsPercent' className='form-label'>
              Bank Guarantee Percent
            </label>
            <input
              id='bankGuaranteeDetailsPercent'
              type='text'
              value={bankGuaranteeDetailsPercent}
              onChange={e => setBankGuaranteeDetailsPercent(e.target.value)}
              className='form-control'
              placeholder='e.g. 10%'
            />
          </div>

          {/* Billing Address Nick */}
          <div className='col-md-12'>
            <label htmlFor='billingAddressNick' className='form-label'>
              Select Billing Address
            </label>
            <select
              id='billingAddressNick'
              className='form-select mb-2'
              value={selectedBillingNick}
              onChange={e => {
                const nickName = e.target.value
                setSelectedBillingNick(nickName)
                if (nickName === '') {
                  setBillingAddress('')
                } else {
                  const addr = leadDetails?.client?.address?.find(a => a.addressNickName === nickName)
                  if (addr) {
                    const parts = [addr.addressLine1, addr.addressLine2, addr.city, addr.state, addr.country, addr.pincode].filter(Boolean)
                    setBillingAddress(parts.join(', '))
                  }
                }
              }}
            >
              <option value=''>-- Select Address --</option>
              {(leadDetails?.client?.address || []).map((addr, idx) => (
                <option key={addr._id || idx} value={addr.addressNickName}>
                  {addr.addressNickName}
                </option>
              ))}
            </select>
          </div>

          {/* Billing Address */}
          <div className='col-md-12'>
            <label htmlFor='billingAddress' className='form-label'>
              Billing Address <span className='text-danger'>*</span>
            </label>
            <textarea
              id='billingAddress'
              value={billingAddress}
              onChange={e => setBillingAddress(e.target.value)}
              className='form-control'
              required
            />
          </div>

          {/* Same as billing checkbox */}
          <div className='col-md-12'>
            <div className='form-check'>
              <input
                className='form-check-input'
                type='checkbox'
                checked={checkShipping}
                onChange={e => {
                  setCheckShipping(e.target.checked)
                  if (e.target.checked) {
                    setShippingAddress(billingAddress)
                  } else {
                    setShippingAddress('')
                  }
                }}
                id='flexCheckDefault'
              />
              <label className='form-check-label' htmlFor='flexCheckDefault'>
                Shipping address same as billing address?
              </label>
            </div>
          </div>

          {/* Shipping Address Nick */}
          {!checkShipping && (
            <div className='col-md-12'>
              <label htmlFor='shippingAddressNick' className='form-label'>
                Select Shipping Address
              </label>
              <select
                id='shippingAddressNick'
                className='form-select mb-2'
                value={selectedShippingNick}
                onChange={e => {
                  const nickName = e.target.value
                  setSelectedShippingNick(nickName)
                  if (nickName === '') {
                    setShippingAddress('')
                  } else {
                    const addr = leadDetails?.client?.address?.find(a => a.addressNickName === nickName)
                    if (addr) {
                      const parts = [addr.addressLine1, addr.addressLine2, addr.city, addr.state, addr.country, addr.pincode].filter(Boolean)
                      setShippingAddress(parts.join(', '))
                    }
                  }
                }}
              >
                <option value=''>-- Select Address --</option>
                {(leadDetails?.client?.address || []).map((addr, idx) => (
                  <option key={addr._id || idx} value={addr.addressNickName}>
                    {addr.addressNickName}
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Shipping Address */}
          <div className='col-md-12'>
            <label htmlFor='shippingAddress' className='form-label'>
              Shipping Address <span className='text-danger'>*</span>
            </label>
            <textarea
              id='shippingAddress'
              value={checkShipping ? billingAddress : shippingAddress}
              onChange={e => {
                if (!checkShipping) {
                  setShippingAddress(e.target.value)
                }
              }}
              className='form-control'
              disabled={checkShipping}
              required
            />
          </div>

          {/* Remarks */}
          <div className='col-md-12'>
            <label htmlFor='remarks' className='form-label'>
              Remarks
            </label>
            <textarea
              id='remarks'
              value={remarks}
              onChange={e => setRemarks(e.target.value)}
              className='form-control'
            />
          </div>

          {/* BOM File (Project only) — optional */}
          {leadDetails?.productRequirements?.natureOfSale === 'Project' && (
            <div className='col-md-12'>
              <label htmlFor='bomFile' className='form-label'>
                BOM <span className='text-muted small'>(optional)</span>
              </label>
              <input ref={bomFileInputRef} type='file' className='form-control' />
            </div>
          )}

          {/* Final Order Document */}
          <div className='col-md-12'>
            <label htmlFor='finalOrderDoc' className='form-label'>
              Final Order Document
            </label>
            <input
              id='finalOrderDoc'
              ref={finalOrderDocInputRef}
              type='file'
              accept='.pdf'
              className='form-control'
            />
            <small className='text-muted'>Optional — upload the final signed order document (PDF only).</small>
          </div>

          {/* Payment Terms */}
          <div className='col-md-12'>
            <h4 className='text-lg font-semibold mb-3'>Payment Terms</h4>
          </div>

          {paymentTerms.map((term, index) => (
            <Fragment key={index}>
              <div className='col-md-5 mb-3'>
                <label className='form-label'>
                  Payment Type <span className='text-danger'>*</span>
                </label>
                <select
                  className='form-select'
                  value={term.type}
                  onChange={e => {
                    const newType = e.target.value
                    handlePaymentTermChange(index, 'type', newType)
                    if (newType !== 'Others') {
                      handlePaymentTermChange(index, 'otherDetails', '')
                    }
                  }}
                >
                  <option value=''>Select</option>
                  <option value='Advance along with Purchase order'>Advance along with Purchase order</option>
                  <option value='Payment against submission of drawings'>Payment against submission of drawings</option>
                  <option value='Payment against proof of placement of Purchase order to vendor'>
                    Payment against proof of placement of Purchase order to vendor
                  </option>
                  <option value='Payment against pro-forma invoice before despatch along with 100% GST'>
                    Payment against pro-forma invoice before despatch along with 100% GST
                  </option>
                  <option value='Payment against pro-forma invoice before despatch along with prorata GST'>
                    Payment against pro-forma invoice before despatch along with prorata GST
                  </option>
                  <option value='Payment against despatch document'>Payment against despatch document</option>
                  <option value='Payment on receipt of material at site'>Payment on receipt of material at site</option>
                  <option value='Payment on stage completion of erection'>Payment on stage completion of erection</option>
                  <option value='Payment against completion of erection'>Payment against completion of erection</option>
                  <option value='Payment against completion of commissioning'>Payment against completion of commissioning</option>
                  <option value='Payment on completion of DLP'>Payment on completion of DLP</option>
                  <option value='Payment within 7/15/21/30/45/60/90 days from date of receipt of material'>
                    Payment within 7/15/21/30/45/60/90 days from date of receipt of material
                  </option>
                  <option value='Others'>Others</option>
                </select>
              </div>

              <div className='col-md-2 mb-3'>
                <label className='form-label'>
                  Percentage <span className='text-danger'>*</span>
                </label>
                <input
                  type='number'
                  onWheel={e => e.target.blur()}
                  className='form-control'
                  value={term.percentage}
                  onChange={e => handlePaymentTermChange(index, 'percentage', e.target.value)}
                />
              </div>

              <div className='col-md-2 mb-3'>
                <label className='form-label'>
                  Amount <span className='text-danger'>*</span>
                </label>
                <input
                  type='number'
                  onWheel={e => e.target.blur()}
                  className='form-control'
                  value={term.amount}
                  onChange={e => handlePaymentTermChange(index, 'amount', e.target.value)}
                />
              </div>

              {term.type === 'Others' && (
                <div className='col-md-2 mb-3'>
                  <label className='form-label'>
                    Other Details <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='text'
                    className='form-control'
                    value={term.otherDetails || ''}
                    onChange={e => handlePaymentTermChange(index, 'otherDetails', e.target.value)}
                    placeholder='Please specify'
                  />
                </div>
              )}

              <div className='col-md-1 col-12 mb-3 d-flex align-items-end justify-content-center gap-2'>
                <button
                  type='button'
                  className='btn add-btn text-white d-flex justify-content-center align-items-center'
                  onClick={addPaymentTerm}
                >
                  +
                </button>
                {index > 0 && (
                  <button
                    type='button'
                    className='btn btn-danger d-flex justify-content-center align-items-center'
                    onClick={() => removePaymentTerm(index)}
                  >
                    -
                  </button>
                )}
              </div>
            </Fragment>
          ))}

          {/* Select Manager */}
          <div className='col-md-6'>
            <label htmlFor='selectManager' className='form-label'>
              Select Manager <span className='text-danger'>*</span>
            </label>
            <Select
              options={managerDetails}
              placeholder='Select Manager'
              value={managerDetails.find(option => option.value === manager) || null}
              onChange={e => setManager(e ? e.value : '')}
              isClearable
            />
          </div>

          {/* Submit */}
          <div className='col-md-12 d-flex justify-content-between'>
            <TerminateConfirmationModal leadId={id} />
            <button
              onClick={handleSubmit}
              className='btn add-btn text-white'
              type='button'
              disabled={submitting}
            >
              {submitting ? 'Submitting...' : 'Submit'}
            </button>
          </div>
        </form>

        {/* Success Modal */}
        <Modal show={showSuccessModal} centered>
          <Modal.Body>
            <div className='my-8 text-center'>
              <svg xmlns='http://www.w3.org/2000/svg' className='w-14 shrink-0 fill-green-500 inline' viewBox='0 0 512 512'>
                <path d='M383.841 171.838c-7.881-8.31-21.02-8.676-29.343-.775L221.987 296.732l-63.204-64.893c-8.005-8.213-21.13-8.393-29.35-.387-8.213 7.998-8.386 21.137-.388 29.35l77.492 79.561a20.687 20.687 0 0 0 14.869 6.275 20.744 20.744 0 0 0 14.288-5.694l147.373-139.762c8.316-7.888 8.668-21.027.774-29.344z' />
                <path d='M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0zm0 470.487c-118.265 0-214.487-96.214-214.487-214.487 0-118.265 96.221-214.487 214.487-214.487 118.272 0 214.487 96.221 214.487 214.487 0 118.272-96.215 214.487-214.487 214.487z' />
              </svg>
              <h4 className='text-xl text-gray-800 font-semibold mt-4'>Good Job</h4>
              <p className='text-sm text-gray-500 leading-relaxed mt-4'>{modalMessage}!</p>
            </div>
            <button
              type='button'
              onClick={handleCloseModal}
              className='px-5 py-2.5 w-full rounded-lg text-white text-sm border-none outline-none bg-green-500 hover:bg-green-700'
            >
              Okay
            </button>
          </Modal.Body>
        </Modal>

        {/* Error Modal */}
        <Modal show={showDeclineModal} centered>
          <Modal.Body>
            <div className='my-8 text-center'>
              <svg xmlns='http://www.w3.org/2000/svg' className='w-14 fill-red-500 inline' viewBox='0 0 286.054 286.054'>
                <path
                  fill='#e2574c'
                  d='M143.027 0C64.04 0 0 64.04 0 143.027c0 78.996 64.04 143.027 143.027 143.027 78.996 0 143.027-64.022 143.027-143.027C286.054 64.04 222.022 0 143.027 0zm0 259.236c-64.183 0-116.209-52.026-116.209-116.209S78.844 26.818 143.027 26.818s116.209 52.026 116.209 116.209-52.026 116.209-116.209 116.209zm.009-196.51c-10.244 0-17.995 5.346-17.995 13.981v79.201c0 8.644 7.75 13.972 17.995 13.972 9.994 0 17.995-5.551 17.995-13.972V76.707c-.001-8.43-8.001-13.981-17.995-13.981zm0 124.997c-9.842 0-17.852 8.01-17.852 17.86 0 9.833 8.01 17.843 17.852 17.843s17.843-8.01 17.843-17.843c-.001-9.851-8.001-17.86-17.843-17.86z'
                />
              </svg>
              <h4 className='text-xl text-gray-800 font-semibold mt-4'>Error Occured</h4>
              <p className='text-sm text-gray-500 leading-relaxed mt-4'>{modalMessage}!</p>
            </div>
            <button
              type='button'
              onClick={handleCloseModal}
              className='px-5 py-2.5 w-full rounded-lg text-white text-sm border-none outline-none bg-red-500 hover:bg-red-700'
            >
              Okay
            </button>
          </Modal.Body>
        </Modal>

        <Toast ref={toast} />
      </div>
    </Fragment>
  )
}

export default ReachedAgreement